import { render, staticRenderFns } from "./MixingIncome.vue?vue&type=template&id=6af04501&scoped=true&"
import script from "./MixingIncome.vue?vue&type=script&lang=js&"
export * from "./MixingIncome.vue?vue&type=script&lang=js&"
import style0 from "./MixingIncome.vue?vue&type=style&index=0&id=6af04501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af04501",
  null
  
)

export default component.exports